export enum LocalMessageType {
  SUCCESS   = 'SUCCESS',
  ERROR     = 'ERROR',
  INFO      = 'INFO',
  WARNING   = 'WARNING'
}
